import { FormComponentBuilder } from 'components/common/form/layout';
import { FormControlProps } from 'components/common/form/layout/control';

export interface FormControlResourceTypeLabelProps extends FormControlProps {
    label: string;
    icon: string;
}

export class FormResourceTypeLabelBuilder extends FormComponentBuilder {
    prepareProps(): FormControlResourceTypeLabelProps {
        return {
            ...this.controlProps,
            label: this.elementProps.componentProps?.label ?? '',
            icon: this.elementProps.componentProps?.icon ?? '',
        };
    }
}
